var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5002 17.5L13.881 13.8809M13.881 13.8809C14.5001 13.2618 14.9912 12.5269 15.3262 11.718C15.6612 10.9091 15.8337 10.0422 15.8337 9.16672C15.8337 8.29121 15.6612 7.42429 15.3262 6.61543C14.9912 5.80657 14.5001 5.07162 13.881 4.45255C13.2619 3.83348 12.527 3.3424 11.7181 3.00736C10.9093 2.67232 10.0423 2.49988 9.16684 2.49988C8.29134 2.49988 7.42441 2.67232 6.61555 3.00736C5.80669 3.3424 5.07174 3.83348 4.45267 4.45255C3.2024 5.70282 2.5 7.39856 2.5 9.16672C2.5 10.9349 3.2024 12.6306 4.45267 13.8809C5.70295 15.1312 7.39868 15.8336 9.16684 15.8336C10.935 15.8336 12.6307 15.1312 13.881 13.8809Z",
    stroke: "#6B6C80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVector);
export default __webpack_public_path__ + "static/media/SearchVector.b4dd836ffeb0bbc7ce8ac1b2297bb864.svg";
export { ForwardRef as ReactComponent };